import React from 'react';

import {createRoot} from 'react-dom/client';

import App from './app/App';
import auth from './app/auth';
import {initDatadog} from './utils/datadog';

initDatadog();

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);

auth(success => {
  if (success) {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  } else {
    root.render(
      <React.StrictMode>
        <h1>Error al autenticar</h1>
      </React.StrictMode>,
    );
  }
});
